<template>
  <v-container>
    <!-- CIRCULO ABAJO DERECHA -->
    <v-speed-dial
      v-model="fab"
      fixed
      direction="top"
      :transition="transition"
      style="bottom: 37px; right: 30px"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="blue lighten-1"
          dark
          fab
          @click="dialog = true"
        >
          <v-icon>mdi-filter </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>
    <!-- FIN CIRCULO ABAJO DERECHA -->

    <!-- FILTRO -->
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <!-- Header -->
          <v-card-title>
            <span class="text-h5">Buscador</span>
          </v-card-title>
          <!-- Body -->
          <v-card-text>
            <v-container>
              <!-- Proveedor -->
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    :loading="loadingProveedores"
                    v-model="proveedor"
                    :items="proveedores"
                    :search-input.sync="buscarProveedor"
                    :error-messages="errorProveedor"
                    @keyup="
                      debounceSearch(() => buscarProveedores());
                      loadingProveedores = true;
                    "
                    chips
                    color="blue-grey lighten-2"
                    label="Proveedor"
                    item-text="RazonSocial"
                    item-value="RazonSocial"
                    return-object
                  >
                    <template v-if="loadingProveedores" slot="no-data"
                      ><p class="ma-2 ml-4">Buscando...</p></template
                    >
                    <template v-else-if="buscarProveedor" slot="no-data"
                      ><p class="ma-2 ml-4">
                        No se han encontrado coincidencias con el texto
                        introducido.
                      </p></template
                    >
                    <template v-else slot="no-data"
                      ><p class="ma-2 ml-4">
                        Empieza a escribir para buscar.
                      </p></template
                    >
                    <template v-slot:selection="">
                      <v-chip close @click:close="proveedor = {}">
                        {{ proveedor.RazonSocial }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <!-- Fechas -->
              <v-row>
                <!-- Desde -->
                <v-col cols="12" sm="6">
                  <v-dialog
                    ref="dialog"
                    v-model="calendario.desde.mostrar"
                    :return-value.sync="calendario.desde.date"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="calendario.desde.fecha"
                        clearable
                        @click:clear="
                          calendario.desde.fecha = '';
                          calendario.desde.date = '';
                        "
                        label="Desde:"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="calendario.desde.date"
                      scrollable
                      :max="fechaMaxima()"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text @click="calendario.desde.mostrar = false">
                        Cancelar
                      </v-btn>
                      <v-btn
                        text
                        color="green darken-1"
                        @click="$refs.dialog.save(calendario.desde.date)"
                      >
                        Aceptar
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <!-- Hasta -->
                <v-col cols="12" sm="6">
                  <v-dialog
                    ref="dialog2"
                    v-model="calendario.hasta.mostrar"
                    :return-value.sync="calendario.hasta.date"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="calendario.hasta.fecha"
                        clearable
                        @click:clear="
                          calendario.hasta.fecha = '';
                          calendario.hasta.date = '';
                        "
                        label="hasta:"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="calendario.hasta.date"
                      scrollable
                      :min="calendario.desde.date"
                      :max="hoy"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text @click="calendario.hasta.mostrar = false">
                        Cancelar
                      </v-btn>
                      <v-btn
                        text
                        color="green darken-1"
                        @click="$refs.dialog2.save(calendario.hasta.date)"
                      >
                        Aceptar
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>
              <!-- Material -->
              <v-row>
                <v-col cols="12" class="pt-0">
                  <v-autocomplete
                    :loading="loadingMateriales"
                    v-model="material"
                    :items="materiales"
                    :search-input.sync="buscarMaterial"
                    :error-messages="errorMaterial"
                    @keyup="
                      debounceSearch(() => buscarMateriales());
                      loadingMateriales = true;
                    "
                    chips
                    color="blue-grey lighten-2"
                    label="Material"
                    return-object
                    :filter="filterObject"
                  >
                    <!-- Si esta buscando -->
                    <template v-if="loadingMateriales" slot="no-data"
                      ><p class="ma-2 ml-4">Buscando...</p></template
                    >
                    <!-- Si hay texto pero no se encuentran coincidencias -->
                    <template v-else-if="buscarMaterial" slot="no-data"
                      ><p class="ma-2 ml-4">
                        No se han encontrado coincidencias con el texto
                        introducido.
                      </p></template
                    >
                    <!-- Si no hay nada para buscar -->
                    <template v-else slot="no-data"
                      ><p class="ma-2 ml-4">
                        Empieza a escribir para buscar.
                      </p></template
                    >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click:close="material = undefined"
                      >
                        {{ data.item.CodigoArticulo }} -
                        {{ data.item.DescripcionArticulo }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title
                            >{{ data.item.CodigoArticulo }} -
                            {{
                              data.item.DescripcionArticulo
                            }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <!-- Footer -->
          <v-card-actions>
            <v-btn color="red darken-1" text @click="borrarFormulario()">
              Borrar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="dialog = false"> Cerrar </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="
                dialog = false;
                verOfertas();
              "
            >
              Buscar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- FIN FILTRO -->

    <!-- Ofertas -->
    <v-row>
      <v-col>
        Filtrado por:
        <span
          v-if="
            !this.filtradoPor.Proveedor.filtrando &&
            !this.filtradoPor.Fecha.filtrando &&
            !this.filtradoPor.Material.filtrando
          "
        >
          <v-chip class="ma-2" color="primary" outlined pill>
            Mostrando todos los resultados
          </v-chip>
        </span>
        <span v-for="(item, index) in this.filtradoPor" :key="index">
          <!-- item.filtrando -->
          <v-chip
            v-if="item.filtrando"
            class="ma-2"
            color="primary"
            outlined
            pill
            close
            @click:close="quitarFiltro(item)"
            >{{ item.texto }}
          </v-chip>
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card :loading="ofertas.loading">
          <v-card-title>
            <v-text-field
              v-model="buscador"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="ofertas.headers"
            :items="ofertas.ofertas"
            :items-per-page="10"
            :search="buscador"
            :sort-by.sync="ofertas.sortBy"
            :sort-desc.sync="ofertas.sortDesc"
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20, -1],
            }"
            class="elevation-1"
          >
            <!-- <template v-slot:item.empresa.Empresa="{ item }">
                <v-chip
                    class="ma-2"
                    small
                    outlined
                    
                    :color="((function () {
                        let color;
                        
                        return color;
                    })(item)) "
                >
                    {{ item.empresa.Empresa }}
                </v-chip>
            </template> -->
            <template v-slot:item.FechaOferta="{ item }">
              {{ formatarFecha(item.FechaOferta) }}
            </template>
            <template v-slot:item.estado="{ item }">
              <v-chip
                class="ma-2"
                small
                outlined
                :color="formatarEstado(item.estado).color"
                >{{ formatarEstado(item.estado).texto }}</v-chip
              >
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="verLineas(item)">
                mdi-eye
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <!-- FIN OFERTAS -->

    <!-- LINEAS -->
    <v-dialog v-model="dialogLineas">
      <v-card>
        <v-card-title>
          <span class="text-h5">Líneas</span>
        </v-card-title>
        <v-card-text>
          <template>
            <v-data-table
              :headers="lineas.headers"
              :items="lineas.lineas"
              :items-per-page="-1"
              hide-default-footer
              :loading="lineas.loading"
              loading-text="Cargando..."
              class="elevation-1"
            >
              <template v-slot:item.Peso="{ item }">
                {{ redondear(item.Peso, 4) }}
              </template>
              <template v-slot:item.Precio="{ item }">
                {{ redondear(item.Precio, 2) }}
              </template>
              <template v-slot:item.Porcen_Exito_Oferta="{ item }">
                {{ redondear(item.Porcen_Exito_Oferta, 0) + "%" }}
              </template>
            </v-data-table>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialogLineas = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIN LINEAS -->
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";
import formatearFecha from "@/mixins/formatearFecha";
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export default {
  mixins: [formatearFecha],
  name: "historicoOfertas",
  data() {
    return {
      //FILTRANDO POR//
      filtradoPor: {
        Proveedor: { texto: "Proveedor", filtrando: false, id: 0 },
        Fecha: { texto: "Fecha", filtrando: true, id: 1 },
        Material: { texto: "Material", filtrando: false, id: 2 },
      },
      //FIN FILTRANDO POR//

      //TABLA//
      //Buscador
      buscador: "",
      //Ofertas
      ofertas: {
        headers: [
          { text: "Empresa", value: "empresa.Empresa" },
          { text: "Fecha", value: "FechaOferta" },
          { text: "Serie", value: "SerieOferta" },
          { text: "Número Oferta", value: "NumeroOferta" },
          { text: "Razón Social", value: "RazonSocial" },
          { text: "Observación Oferta", value: "ObservacionesOferta" },
          { text: "Estado", value: "estado", align: "center", sortable: false },
          { text: "", value: "actions", sortable: false },
        ],
        ofertas: [],
        loading: null,
        sortBy: "FechaOferta",
        sortDesc: true,
      },
      //Lineas
      dialogLineas: "",
      lineas: {
        headers: [
          { text: <v-icon>mdi-cart</v-icon>, value: "CodigoArticulo", sortable: false },
          { text: <v-icon>mdi-weight</v-icon>, value: "Peso", sortable: false },
          { text: "Descripción", value: "DescripcionArticulo", sortable: false },
          { text: <v-icon>mdi-currency-eur</v-icon>, value: "Precio", sortable: false },
          { text: "% Éxito", value: "Porcen_Exito_Oferta", sortable: false },
          { text: "Motivo baja", value: "UVE_MotivoBajaOferta", sortable: false },
        ],
        lineas: [],
        loading: null,
      },
      //FIN TABLA//

      //CIRCULO ABAJO DERECHA//
      fab: false,
      transition: "slide-y-reverse-transition",
      //FIN CIRCULO ABAJO DERECHA//

      //FILTRO//
      dialog: false,
      //Campo Proveedor
      proveedores: [],
      loadingProveedores: false,
      proveedor: {},
      buscarProveedor: "",
      errorProveedor: "",
      //Campos Fecha
      calendario: {
        desde: {
          mostrar: false,
          fecha: "", //Fecha DD/MM/YYYY
          date: "", //Fecha YYYY-MM-DD
        },
        hasta: {
          mostrar: false,
          fecha: "",
          date: "",
        },
      },
      hoy: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      //Campo Material
      materiales: [],
      loadingMateriales: false,
      material: undefined,
      buscarMaterial: "",
      errorMaterial: "",
      //FIN FILTRO//
    };
  },
  watch: {
    "calendario.desde.date"(val) {
      this.calendario.desde.fecha = this.formatDate(this.calendario.desde.date);
    },
    "calendario.hasta.date"(val) {
      this.calendario.hasta.fecha = this.formatDate(this.calendario.hasta.date);
    },
  },
  methods: {
    ...mapActions(["setLoading", "setSnackbar"]),
    //API
    async verOfertas() {
      this.ofertas.loading = true;
      if (this.proveedor.RazonSocial) {
        this.filtradoPor.Proveedor.filtrando = true;
      } else {
        this.filtradoPor.Proveedor.filtrando = false;
      }

      if (this.calendario.desde.fecha || this.calendario.hasta.fecha) {
        this.filtradoPor.Fecha.filtrando = true;
      } else {
        this.filtradoPor.Fecha.filtrando = false;
      }

      if (this.material) {
        this.filtradoPor.Material.filtrando = true;
      } else {
        this.filtradoPor.Material.filtrando = false;
      }

      let material = "";
      if (
        this.material != "" &&
        this.material != null &&
        this.material != undefined
      ) {
        material = this.material.CodigoArticulo;
      } else {
        material = "";
      }

      try {
        let params = {
          fechaDesde: this.calendario.desde.date,
          fechaHasta: this.calendario.hasta.date,
          material: material
        };
        if(this.proveedor.RazonSocial){
          params.razonSocial = this.proveedor.RazonSocial
        }

        let respuesta = await axios.get('/api/historico-ofertas', { params });
        this.ofertas.ofertas = respuesta.data;
      } catch (error) {
        // console.log(error);
        this.setSnackbar({
          snackbar: true,
          tipo: "error",
          mensaje: "Error. No se han podido obtener las ofertas pendientes",
        });
      }
      this.ofertas.loading = false;
    },
    async verLineas(item) {
      this.setLoading(true);
      this.lineas.lineas = [];
      this.lineas.loading = true;
      try {
        let respuesta = await axios.get(
          `/api/ofertas-pendientes/lineas?id=${item.idOfertaPro}`
        );
        this.lineas.lineas = respuesta.data;
        this.dialogLineas = true;
      } catch (error) {
        // console.log(error);
        this.setSnackbar({
          snackbar: true,
          tipo: "error",
          mensaje: "Error. No se han podido obtener las líneas de la oferta",
        });
      }
      this.setLoading(false);
      this.lineas.loading = false;
    },
    async buscarProveedores() {
      this.proveedores = [];
      this.loadingProveedores = true;
      if (this.buscarProveedor) {
        try {
          let respuesta = await axios.get(
            `/api/historico-ofertas/proveedor?proveedor=${this.buscarProveedor}`
          );
          this.proveedores = respuesta.data;
        } catch (error) {
          this.setSnackbar({
            snackbar: true,
            tipo: "error",
            mensaje: "Error. No se han podido obtener los proveedores",
          });
        }
      }
      this.loadingProveedores = false;
    },
    async buscarMateriales() {
      this.materiales = [];
      if (this.buscarMaterial) {
        try {
          let respuesta = await axios.get(
            `/api/historico-ofertas/material?material=${this.buscarMaterial}`
          );
          this.materiales = respuesta.data;
        } catch (error) {
          // console.log(error);
        }
      }
      this.loadingMateriales = false;
    },

    //Dar formato
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    redondear(numero, decimales) {
      numero = Number(numero).toFixed(decimales).toString().split(".");
      numero[0] = numero[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return numero.join(",");
    },
    formatarEstado(estado) {
      let chip = { texto: "", color: "" };
      switch (parseInt(estado)) {
        case 0:
          chip.texto = "Pendiente";
          chip.color = "blue";
          break;

        case 1:
          chip.texto = "Bloqueada";
          chip.color = "red";
          break;

        case 2:
          chip.texto = "Capturada";
          chip.color = "green";
          break;

        default:
          chip.texto = "Sin asignar";
          break;
      }
      return chip;
    },

    //Otros
    borrarFormulario() {
      this.proveedor = "";
      this.calendario.desde.fecha = "";
      this.calendario.desde.date = "";
      this.calendario.hasta.fecha = "";
      this.calendario.hasta.date = "";
      this.material = "";
    },
    debounceSearch(func) {
      // if(this.$v.clienteSeleccionado.$invalid){

      // }else{
      //     this.loadingObras = true;
      // }
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        func.apply();
      }, 600);
    },
    fechaMaxima() {
      let date = this.hoy;
      if (this.calendario.hasta.date != "") {
        date = this.calendario.hasta.date;
      }
      return date;
    },
    filterObject(item) {
      return item;
    },
    quitarFiltro(item) {
      switch (item.id) {
        case 0:
          this.proveedor = "";
          break;

        case 1:
          this.calendario.desde.fecha = "";
          this.calendario.desde.date = "";
          this.calendario.hasta.fecha = "";
          this.calendario.hasta.date = "";
          break;

        case 2:
          this.material = "";
          break;
      }
      this.verOfertas();
    },
    buscarUltimoAño() {
      const date = new Date();
      this.calendario.desde.date = `${date.getFullYear() - 1}-${
        date.getMonth() + 1
      }-${date.getDate()}`; //yyyy-m-d
      this.calendario.desde.fecha = this.formatDate(this.calendario.desde.date);
      this.verOfertas();
    },
  },
  mounted() {
    this.buscarUltimoAño();
    // this.verOfertas()
  },
};
</script>